import { NotifyHelper } from "../../../helpers/toast";
import { eGioHocRangBuocActionsObj } from "../../action-types/category/IGioHocRangBuocActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const gioHocRangBuocActions = {
    ...generateActions(eGioHocRangBuocActionsObj, "GIO_HOC_RANG_BUOC"),
    ...generateActionForKey(eGioHocRangBuocActionsObj, "GIO_HOC_RANG_BUOC", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eGioHocRangBuocActionsObj, "GIO_HOC_RANG_BUOC", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eGioHocRangBuocActionsObj, "GIO_HOC_RANG_BUOC", "SAVE_ERRR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eGioHocRangBuocActionsObj, "GIO_HOC_RANG_BUOC", "DELETE_ERRR", (m) => { NotifyHelper.Error(m) }),
};
